import React from "react";
import PropTypes from "prop-types";
import {withNamespaces} from "react-i18next";
import {toTitleCase} from "../../utils";
import styles from "../RouteRow/RouteRow.scss";
import {traceDefaultSpeeds} from "../../constants";

const ROAD_TYPE_NAMES = {
  otherType: "trace-common-road-type-other",        // "Другой тип"
  common: "trace-common-road-type-common",          // "Общего пользования"
  trunk: "trace-common-road-type-trunk",            // "Магистраль"
  motorway: "trace-common-road-type-motorway",      // "Автомагистраль"
  winterRoad: "trace-common-road-type-winter-road", // "Зимник"
  ferry: "trace-common-road-type-ferry"             // "Паромная переправа"
};

const getRouteSpeed = type => {
  switch (type){
    case 'ferry':
      return traceDefaultSpeeds.ferry;
    case 'winterRoad':
      return traceDefaultSpeeds.winterRoad;
    case 'otherType':
      return traceDefaultSpeeds.other;
    case 'common':
      return traceDefaultSpeeds.main;
    case 'trunk':
      return traceDefaultSpeeds.trunk;
    case 'motorway':
      return traceDefaultSpeeds.motorway;
  }
};

const RouteRoadImage = props => {
  const { traveledRoutes, t } = props;
  const totalDistance = traveledRoutes.reduce((acc, current) => acc + current.distance, 0);

  return traveledRoutes.map((traveledRoute, index) => {
    const routeCss = `${styles.traceRoad} ${styles[`roadType-${traveledRoute.type}`]}`;
    const percent = Math.round(traveledRoute.distance / totalDistance * 100);
    const style = {height: `${percent}%`};
    const text = t(ROAD_TYPE_NAMES[traveledRoute.type]);
    const routeTypeName = toTitleCase(text);
    const routeSpeed = getRouteSpeed(traveledRoute.type);
    const routeTitle = `${routeTypeName}, ${routeSpeed} ${t("trace-common-units-speed-abbreviation", "км/ч")}`;

    return <div key={index} className={routeCss} style={style} title={routeTitle}/>;
  });
};

RouteRoadImage.propTypes = {
  traveledRoutes: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func.isRequired
};

export default withNamespaces()(RouteRoadImage);
